import React from "react";
import { useWishlist } from "../context/WishlistContext";
import ProductCard from "../components/ProductCard";

export default function WishlistPage() {
  const { wishlist } = useWishlist();

  // 🟡 Empty state
  if (!wishlist || wishlist.length === 0) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center text-center px-4">
        <h2 className="text-2xl font-semibold text-[#5B2E3C]">
          Your wishlist is empty 💔
        </h2>
        <p className="mt-2 text-gray-500">
          Like products to see them here.
        </p>
      </div>
    );
  }

  // ✅ Wishlist has products
  return (
    <div className="min-h-screen max-w-6xl mx-auto px-4 py-10">
      <h1 className="text-3xl font-bold text-[#5B2E3C] mb-8 text-center">
        My Wishlist ❤️
      </h1>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6">
        {wishlist.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </div>
  );
}
